import React, { useState } from "react";
import DataTable from "components/DataTable";
import { useTableData } from "../../hooks/useTableData";
import PageWrapper from "components/PageWrapper";
import { panCardReportsConfig } from "config/tableConfigs";
import { useSession } from "hooks/useSession";
import PanCardDocumentsModal from "./PancardDocumentModel";

const PanCardReportsPage = () => {
  const { userid } = useSession();
  const [showModal, setShowModal] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);
const [refresh, setRefresh] = useState(0);

const refreshData = () => setRefresh((p) => p + 1);

  /* ===== Default last 7 days ===== */
  const getLast7Days = () => {
    const today = new Date();
    const last7 = new Date();
    last7.setDate(today.getDate() - 1);

    return {
      start: last7.toISOString().split("T")[0],
      end: today.toISOString().split("T")[0],
    };
  };

  const { start, end } = getLast7Days();

  const [apiUrl, setApiUrl] = useState(
    `https://api.mokshiq.in/pancard_report?user=${userid}&filter_date=${start}&end_date=${end}`
  );

  const tableData = useTableData(`${apiUrl}&r=${refresh}`, panCardReportsConfig);

  /* ===== Date Filter Handler ===== */
  const handleDateFilter = (startDate, endDate) => {
    setApiUrl(
      `https://api.mokshiq.in/pancard_report?user=${userid}&filter_date=${startDate}&end_date=${endDate}`
    );
  };

  /* ===== View Documents ===== */
  const handleView = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };
  
  

  return (
    <div>
        <PageWrapper
      config={panCardReportsConfig}
      onDateFilter={handleDateFilter}
    >
      <DataTable
        config={panCardReportsConfig}
        tableData={tableData}
        onView={handleView}
        onEdit={() => {}}
        onDelete={() => {}}
        onExport={() => {}}
        onDeleteSelected={() => {}}
      />
    </PageWrapper>
    <PanCardDocumentsModal
  isOpen={showModal}
  data={selectedRow}
  onClose={() => setShowModal(false)}
  refresh={refreshData}
/>

    </div>
    
  );
};

export default PanCardReportsPage;
